import { render, staticRenderFns } from "./FileBrowser.vue?vue&type=template&id=66c78a1e&scoped=true"
import script from "./FileBrowser.vue?vue&type=script&lang=js"
export * from "./FileBrowser.vue?vue&type=script&lang=js"
import style0 from "./FileBrowser.vue?vue&type=style&index=0&id=66c78a1e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c78a1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66c78a1e')) {
      api.createRecord('66c78a1e', component.options)
    } else {
      api.reload('66c78a1e', component.options)
    }
    module.hot.accept("./FileBrowser.vue?vue&type=template&id=66c78a1e&scoped=true", function () {
      api.rerender('66c78a1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser-product-selector/FileBrowser.vue"
export default component.exports